import React, { useState } from 'react';
import { Clock, DollarSign, Check } from 'lucide-react';
import { Button } from '../ui/button';

const formatPrice = (cents) => `$${(cents / 100).toFixed(2)}`;
const formatDuration = (minutes) => {
  if (minutes < 60) return `${minutes} min`;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return m === 0 ? `${h} hr` : `${h} hr ${m} min`;
};

export const StepVariation = ({ service, onSelect }) => {
  const [picked, setPicked] = useState(null);

  return (
    <div className="space-y-4" data-testid="step-variation">
      <p className="text-neutral-600 text-sm">
        Choose the package that fits your needs:
      </p>

      <div className="space-y-3">
        {service.variations.map((v) => {
          const isSelected = picked?.variation_id === v.variation_id;
          const label = v.variation_name && v.variation_name.trim() && v.variation_name !== 'Regular'
            ? v.variation_name
            : `${formatDuration(v.duration_minutes)} • ${formatPrice(v.price_cents)}`;

          return (
            <button
              key={v.variation_id}
              type="button"
              onClick={() => setPicked(v)}
              data-testid={`variation-${v.variation_id}`}
              className={`w-full text-left p-4 rounded-sm border-2 transition-all ${
                isSelected
                  ? 'bg-red-600/10 border-red-500'
                  : 'bg-white border-neutral-200 hover:border-red-500'
              }`}
            >
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="text-neutral-900 font-semibold text-base mb-1">{label}</div>
                  <div className="flex items-center gap-4 text-neutral-600 text-sm">
                    <span className="flex items-center gap-1">
                      <Clock className="w-3.5 h-3.5" />
                      {formatDuration(v.duration_minutes)}
                    </span>
                    <span className="flex items-center gap-1">
                      <DollarSign className="w-3.5 h-3.5" />
                      {formatPrice(v.price_cents)}
                    </span>
                  </div>
                </div>
                {isSelected && (
                  <div className="w-6 h-6 rounded-full bg-red-600 flex items-center justify-center shrink-0">
                    <Check className="w-4 h-4 text-white" />
                  </div>
                )}
              </div>
            </button>
          );
        })}
      </div>

      <Button
        type="button"
        disabled={!picked}
        onClick={() => onSelect(picked)}
        className="w-full bg-red-600 hover:bg-red-700 disabled:bg-neutral-200 disabled:text-neutral-500"
        data-testid="step-variation-continue"
      >
        Continue
      </Button>
    </div>
  );
};
